import { TextareaHTMLAttributes } from 'react'
import { Controller, FieldValues } from 'react-hook-form'
import { ControlledFieldProps } from '@/root/shared-types/form/controlledField'
import cn from 'classnames'

type ControlledTextareaProps<T extends FieldValues> = ControlledFieldProps<T> &
  TextareaHTMLAttributes<HTMLTextAreaElement>

export const ControlledTextarea = <T extends FieldValues>({
  name,
  control,
  disabled,
  ...rest
}: ControlledTextareaProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <textarea
          rows={2}
          disabled={disabled}
          {...field}
          {...rest}
          className={cn(
            'border-neutral-medium-lighter text-neutral-darker focus:border-primary-base w-full resize-none rounded-lg border bg-white px-2.5 py-0.5 text-base focus:outline-none',
            disabled && 'opacity-50'
          )}
        />
      )}
    />
  )
}
